import type { BaseAttributes } from './BaseTarget';
import { BaseTarget } from './BaseTarget';

export interface AnonymousExperimentAttributes extends BaseAttributes {
  id?: string | number | undefined;
}

class AnonymousExperimentTarget extends BaseTarget {
  constructor(entity: AnonymousExperimentAttributes) {
    super({ id: entity.id });
  }

  // FIXME: Consider using a static method.
  // eslint-disable-next-line class-methods-use-this
  get prefix(): string {
    return 'anon';
  }
}

export { AnonymousExperimentTarget as AnonymousTarget };
